function supportsFontFace() {
  function blacklist() {
    var match = /(WebKit|windows phone.+trident)\/(\d+)/i.exec(navigator.userAgent);
    return match && parseInt(match[2], 10) < (match[1] == 'WebKit' ? 533 : 6);
  }
  function hasFontFaceSrc() {
    var style = document.getElementById('fontsupporttest');
    var sheet = style.sheet || style.styleSheet;
    var cssText = sheet ? (sheet.cssRules && sheet.cssRules[0] ? sheet.cssRules[0].cssText : sheet.cssText || '') : '';
    return /src/i.test(cssText);
  }
  return !blacklist() && hasFontFaceSrc();
}
document.documentElement.classList.replace('no-js', 'js');
if (window.matchMedia("(pointer: coarse)").matches) {document.documentElement.classList.add('touchevents')} else {document.documentElement.classList.add('no-touchevents')}
if (supportsFontFace()) {document.documentElement.classList.add('fontface')}